import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { DefaultLayoutComponent } from './layout/default-layout/default-layout.component';
import { HomeComponent } from './components/home/home.component';
import { ProfileSettingsComponent } from './components/profile/settings.component';
import { Error401Component } from './shared/components/error-code/401.component';
import { Error403Component } from './shared/components/error-code/403.component';
import { Error404Component } from './shared/components/error-code/404.component';
import { Error500Component } from './shared/components/error-code/500.component';
import { AuthGuard } from "./shared/auth/auth-guard";
import { AuthService } from './shared/auth/auth.service';
import { MfaComponent } from './shared/auth/mfa/mfa.component';
import { WelcomeComponent } from './components/welcome/welcome.component';

const routes: Routes = [
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      { path: '', redirectTo: 'welcome', pathMatch: 'full' },
      { path: 'home', component: HomeComponent , 
         canActivate:[AuthGuard], data: { roles: ['Admin','OfficeAdmin','LabTech','ReadOnly'] }
      },
      { path: 'welcome', component: WelcomeComponent },
      { path: 'mfa', component: MfaComponent },
      { path: 'profile', component: ProfileSettingsComponent , canActivate: [AuthGuard], data: { roles: []}},
      { path: 'error/401', component: Error401Component },
      { path: 'error/403', component: Error403Component },
      { path: 'error/404', component: Error404Component },
      { path: 'error/500', component: Error500Component },
      {
        path: 'lab',
        loadChildren: () => import('./components/lab/lab.module').then(m => m.LabModule), 
        canActivate:[AuthGuard], data: { roles: ['Admin','OfficeAdmin','LabTech','ReadOnly']}
      },
      {
        path: 'admin',
        loadChildren: () => import('./components/admin/admin.module').then(m => m.AdminModule), 
        canActivate:[AuthGuard], data: { roles: ['Admin','OfficeAdmin','LabTech']}
      },
      {
        path: 'reports',
        loadChildren: () => import('./components/reports/reports.module').then(m => m.ReportsModule),
        canActivate:[AuthGuard], data: { roles: ['Admin','OfficeAdmin','LabTech']}
      }

    ],
  },
  { path: '**', redirectTo: 'welcome' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    useHash: environment.useHash,
    enableTracing: false
}),
  ],
  exports: [RouterModule],
  declarations: [],
  providers: [AuthService, AuthGuard]
})
export class RoutesRoutingModule {}
